/**
 * Styles responsive spécifiques pour certains appareils mobiles populaires
 */
export const DEVICE_SPECIFIC_STYLES = `
  /* iPhone SE et appareils similaires (375x667) */
  @media (max-width: 375px) and (max-height: 667px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 80px), 420px) !important;
    }
  }

  /* iPhone 12/13/14 en mode portrait (390x844) */
  @media (min-width: 390px) and (max-width: 390px) and (min-height: 844px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 120px), 500px) !important;
    }
  }

  /* iPhone 12/13/14 Pro Max en mode portrait (428x926) */
  @media (min-width: 428px) and (max-width: 428px) and (min-height: 926px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 140px), 550px) !important;
    }
  }

  /* iPhone en mode paysage - tous modèles */
  @media (max-width: 926px) and (orientation: landscape) and (max-height: 428px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 20px), 280px) !important;
      bottom: 2px !important;
    }
    
    .ringado-chat-header {
      padding: 4px 8px !important;
      min-height: 32px !important;
    }
    
    .ringado-messages-container {
      padding: 4px !important;
    }
    
    .ringado-input-area {
      padding: 4px !important;
    }
    
    .ringado-message-bubble {
      padding: 3px 6px !important;
      margin-bottom: 2px !important;
      font-size: 11px !important;
    }
  }

  /* Samsung Galaxy S20/S21 en mode portrait (360x800) */
  @media (max-width: 360px) and (min-height: 800px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 100px), 450px) !important;
    }
  }

  /* Tablettes iPad en mode portrait (768x1024) */
  @media (min-width: 768px) and (max-width: 768px) and (min-height: 1024px) {
    .ringado-chat-modal {
      width: 400px !important;
      height: 650px !important;
      bottom: 24px !important;
      right: 24px !important;
    }
  }

  /* Tablettes iPad en mode paysage (1024x768) */
  @media (min-width: 1024px) and (max-width: 1024px) and (max-height: 768px) {
    .ringado-chat-modal {
      width: 380px !important;
      height: min(calc(100vh - 60px), 550px) !important;
    }
  }

  /* Écrans très larges mais courts (ex: moniteurs ultrawide) */
  @media (min-width: 1200px) and (max-height: 600px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 40px), 450px) !important;
    }
  }

  /* Optimisations pour Safari mobile (détection via CSS) */
  @supports (-webkit-touch-callout: none) {
    @media (max-width: 480px) {
      .ringado-chat-modal {
        /* Ajustement pour la barre d'adresse Safari qui disparaît */
        height: min(calc(100vh - 60px), 400px) !important;
      }
      
      .ringado-input-field {
        /* Éviter le zoom automatique sur iOS */
        font-size: 16px !important;
        transform: none !important;
      }
    }
  }

  /* Support pour les encoches d'écran (iPhone X et plus récents) */
  @supports (padding: max(0px)) {
    @media (max-width: 480px) {
      .ringado-chat-modal {
        bottom: max(8px, env(safe-area-inset-bottom)) !important;
        left: max(8px, env(safe-area-inset-left)) !important;
        right: max(8px, env(safe-area-inset-right)) !important;
      }
    }
  }

  /* Mode sombre - adaptation pour les appareils qui le supportent */
  @media (prefers-color-scheme: dark) {
    .ringado-chat-modal {
      /* Ombre plus prononcée en mode sombre */
      box-shadow: 
        0 25px 50px -12px rgba(0, 0, 0, 0.4),
        0 20px 25px -5px rgba(0, 0, 0, 0.3) !important;
    }
  }

  /* Réduction des animations pour les utilisateurs qui préfèrent moins de mouvement */
  @media (prefers-reduced-motion: reduce) {
    .ringado-chat-modal {
      transition: opacity 0.2s ease !important;
      transform: none !important;
    }
    
    .ringado-chat-modal.open {
      transform: none !important;
    }
  }

  /* Optimisations pour les connexions lentes */
  @media (prefers-reduced-data: reduce) {
    .ringado-chat-modal {
      /* Simplifier les ombres pour économiser les ressources */
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
    }
  }
`;
